import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const NY_TIMEZONE = 'America/New_York';

type MarketStatus = {
  /** Stable identifier — translate via `t('snapshotCard:marketStatus.<key>')`. */
  key: 'preMarket' | 'open' | 'afterHours' | 'closed';
  /** English fallback label. Prefer translating via `key` in user-facing copy. */
  label: 'Pre-Market' | 'Market Open' | 'After Hours' | 'Market Closed';
  color: string;
  dot: string;
};

/** Determine US equity market status based on `now` in America/New_York. */
export const getMarketStatus = (
  sys: { color: Record<string, string> },
  now: Date,
): MarketStatus => {
  const et = dayjs(now).tz(NY_TIMEZONE);
  const timeMinutes = et.hour() * 60 + et.minute();
  if (timeMinutes >= 240 && timeMinutes < 570)
    return {
      key: 'preMarket',
      label: 'Pre-Market',
      color: sys.color.warning,
      dot: sys.color.warning,
    };
  if (timeMinutes >= 570 && timeMinutes < 960)
    return {
      key: 'open',
      label: 'Market Open',
      color: sys.color.positive,
      dot: sys.color.positive,
    };
  if (timeMinutes >= 960 && timeMinutes < 1200)
    return {
      key: 'afterHours',
      label: 'After Hours',
      color: sys.color.warning,
      dot: sys.color.warning,
    };
  return {
    key: 'closed',
    label: 'Market Closed',
    color: sys.color.onSurfaceVariant,
    dot: sys.color.onDisabled,
  };
};
